import { motion } from "framer-motion";
import { STATS } from "@/data/content";

export const StatsStrip = () => {
  return (
    <section className="border-b border-border" data-testid="stats-strip">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col gap-1 lg:border-r lg:border-border last:border-r-0 lg:pr-8"
          >
            <span className="text-3xl sm:text-4xl font-semibold tracking-tight text-primary">
              {stat.value}
            </span>
            <span className="text-xs uppercase tracking-widest text-muted-foreground">
              {stat.label}
            </span>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
